const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getAutocheckMileageReportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'AUTOCHECK_MILEAGE_REPORT_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'AUTOCHECK_MILEAGE_REPORT_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'AUTOCHECK_MILEAGE_REPORT_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'AUTOCHECK_MILEAGE_REPORT_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getAutocheckMileageReportReducer;


// WEBPACK FOOTER //
// ./src/reducers/getMileageReport.js